import { useState, useEffect } from 'react';
// fetch
import {getLocations, getAllowedDeliveryTypes} from 'src/fetch/locations';
// const
import { requestStatuses } from 'shared/../constants/store';

const useLocationInfoById = (id) => {
    const [status, setStatus] = useState(requestStatuses.INIT);
    const [location, setLocation] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setStatus(requestStatuses.PENDING);
        Promise.all([
            getLocations({ Ids: id }),
            getAllowedDeliveryTypes()
        ])
        .then(([locations, allowedDeliveryTypes]) => {
            if (locations.length === 0) {
                throw new Error('Location not found!');
            }
            const [location] = locations;
            const found = allowedDeliveryTypes.find(({ value
                                                     }) => value === location.allowedDeliveryType);
            const allowedDeliveryType = found?.description ?? 'N/A';
            const hoursOfOperation = location.beginHoursOfOperation || location.endHoursOfOperation ? `${location.beginHoursOfOperation} - ${location.endHoursOfOperation}` : 'N/A';
            setLocation({
                ...location,
                allowedDeliveryType,
                hoursOfOperation,
            });
            setStatus(requestStatuses.SUCCESS);
        })
        .catch((error) => {
            console.log('Error loading Location info', error);
            setError(error);
            setStatus(requestStatuses.FAILED);
        });
    }, [id]);

    return { status, error, location };
};

export default useLocationInfoById;